import Link from '@carvana/ds-link';
import breakpoints from '@carvana/merch-tailwind/breakpoints';
import SectionWrapper from '@/home/common/SectionWrapper';
import TagId from '~/constants/common/TagId';
import { appAssetsCdnUrl } from '~/constants/environment';
import { useGetIsReturnUser } from '~/context/home/GlobalContext';
import useGetConsumerHref from '~/hooks/common/selectors/useGetConsumerHref';
import useViewport from '~/hooks/home/selectors/useViewport';
import { nativeSrpPayload } from '~/native/common/utils';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';
import optimizeImage from '~/utilities/optimizeImage';
import styles from './PriceDropBanner.module.css';
import {
  BannerContainer,
  HeadlineBanner,
  InnerWrapper,
  LeftSectionBanner,
  RightSectionBanner
} from './PriceDropBanner.styles';

export default function PriceDropBanner() {
  const isReturnUser = useGetIsReturnUser();
  const priceDropDesktop = optimizeImage(
    `${appAssetsCdnUrl}/images/home/price-drop-large.png`,
    {
      quality: 90,
      format: 'auto'
    }
  );
  const priceDropMobile = optimizeImage(
    `${appAssetsCdnUrl}/images/home/price-drop-small.png`,
    {
      quality: 90,
      format: 'auto'
    }
  );

  const { isDesktopMedium } = useViewport();
  const getHref = useGetConsumerHref();
  const priceDropSearchLink = getHref(
    generateSearchLinkFilter({
      filters: { tagIds: [String(TagId.PriceDrop)] }
    })
  );

  return (
    <SectionWrapper
      analyticsSection="Price Drop Banner"
      hasBottomSpacing={isReturnUser}
      hasSideSpacing
    >
      <BannerContainer
        data-testid="Price Drop Banner"
        className={styles.gradient}
      >
        <InnerWrapper>
          <LeftSectionBanner>
            <HeadlineBanner>
              We’re always repricing inventory to make room for more vehicles.
            </HeadlineBanner>
            <Link
              href={priceDropSearchLink}
              data-analytics-id="Home feed card"
              data-analytics-attributes={JSON.stringify({
                description: 'Price drop cta'
              })}
              data-testid="shop-all-price-drops"
              data-native-payload={nativeSrpPayload}
              priority="inverse"
              preventVisitedColor
              size={isDesktopMedium ? 'md' : 'sm'}
            >
              Shop All Price Drops
            </Link>
          </LeftSectionBanner>

          <RightSectionBanner>
            <picture className="h-full">
              <source
                media={`(min-width: ${breakpoints.lg}px)`}
                srcSet={priceDropDesktop}
              />
              <img
                src={priceDropMobile}
                alt="Price Drop Vehicle"
                className="h-full w-auto"
                loading="lazy"
              />
            </picture>
          </RightSectionBanner>
        </InnerWrapper>
      </BannerContainer>
    </SectionWrapper>
  );
}
